__turbopack_context__.v({
  "icon": "VoidLink-module-scss-module__Lu1zAq__icon",
  "link": "VoidLink-module-scss-module__Lu1zAq__link",
});
